<template>
    <!-- 指标 -->
    <Dropdown class="cm-indicator" trigger="custom" :transfer="true" :visible="visible" placement="bottom-start" @on-clickoutside="visible=false">
        <button class="header-button-ghost" style="width:2rem" @click="onShow">
            <!-- <span class="header-button-ghost-span left">{{isDefaultIndicator?'默认':'自定义'}}</span> -->
            <span class="header-button-ghost-span left">{{indicatorRowLength > 0 && indicatorRowLength != indicatLength ? `已选${indicatorRowLength}项`:'所有操作项'}}</span>
            <i class="icon header-button-ghost-down" :class="{tf: visible}"></i>
        </button>
        <DropdownMenu slot="list" class="default-history-manage-list-wrap">
            <div class="indicator-box" :style="{width: w}">
                <div class="indicator-list">

                    <template v-if="indicatorList" v-for="(row,key) in indicatorList">

                        <div class="indicator-row history-row" :key="key" v-if="key == 1 && row.length > 0">

                            <template v-if="typeKey(tableParams.type) && typeKey(tableParams.type) != String(key)">
                                <div class="indicator-item" @click.stop>
                                    <i class="icon icon-checkbox disabled" :class="{'active':indicatorRowSelect[key]}"></i>
                                    <span>{{indicatorRowName[key]}}</span>
                                </div>
                                <div class="history-cell-wrap">
                                    <div class="row-box">
                                        <div class="indicator-item" @click.stop v-for="(item, index) in row" v-if="index < 8" :key="index">
                                            <i class="icon icon-checkbox disabled" :class="{'active':item.selected}"></i>
                                            <span>{{item.name}}</span>
                                        </div>
                                    </div>
                                    <div class="row-box">
                                        <div class="indicator-item" @click.stop v-if="index >= 8" v-for="(item, index) in row" :key="index">
                                            <i class="icon icon-checkbox disabled" :class="{'active':item.selected}"></i>
                                            <span>{{item.name}}</span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="indicator-item" @click.stop="selectIndicatorRow(key)">
                                    <i class="icon icon-checkbox" :class="{'active':indicatorRowSelect[key]}"></i>
                                    <span>{{indicatorRowName[key]}}</span>
                                </div>
                                <div class="history-cell-wrap">
                                    <div class="row-box">
                                        <div class="indicator-item" @click.stop v-for="(item, index) in row" v-if="index < 8" :key="index" @click.stop="item.selected=!item.selected">
                                            <i class="icon icon-checkbox" :class="{'active':item.selected}"></i>
                                            <span>{{item.name}}</span>
                                        </div>
                                    </div>
                                    <div class="row-box">
                                        <div class="indicator-item" @click.stop v-if="index >= 8" v-for="(item, index) in row" :key="index" @click.stop="item.selected=!item.selected">
                                            <i class="icon icon-checkbox" :class="{'active':item.selected}"></i>
                                            <span>{{item.name}}</span>
                                        </div>
                                    </div>
                                </div>
                            </template>

                        </div>
                        <div class="indicator-row " :key="key" v-else-if="row.length > 0 && key != 1">
                            <template v-if="typeKey(tableParams.type) && typeKey(tableParams.type) != String(key)">
                                <div class="indicator-item" @click.stop>
                                    <i class="icon icon-checkbox disabled" :class="{'active':indicatorRowSelect[key]}"></i>
                                    <span>{{indicatorRowName[key]}}</span>
                                </div>
                                <div class="indicator-item" @click.stop v-for="(item, index) in row" :key="index">
                                    <i class="icon icon-checkbox disabled" :class="{'active':item.selected}"></i>
                                    <span>{{item.name}}</span>
                                </div>
                            </template>
                            <template v-else>
                                <div class="indicator-item" @click.stop="selectIndicatorRow(key)">
                                    <i class="icon icon-checkbox" :class="{'active':indicatorRowSelect[key]}"></i>
                                    <span>{{indicatorRowName[key]}}</span>
                                </div>
                                <div class="indicator-item" v-for="(item, index) in row" :key="index" @click.stop="item.selected=!item.selected">
                                    <i class="icon icon-checkbox" :class="{'active':item.selected}"></i>
                                    <span>{{item.name}}</span>
                                </div>
                            </template>

                        </div>

                    </template>

                </div>
                <div class="indicator-footer">
                    <div class="indicator-footer-left">
                        <span @click.stop="clearIndicator" class="btn-blue" style="margin-right:0.2rem;">清除</span>
                        <span @click.stop="resetIndicator" class="btn-blue">全选</span>
                    </div>
                    <div class="indicator-footer-right">
                        <Button @click.stop="onSaveIndicator('cancel')" type="ghost" style="margin-right:0.2rem;">取消</Button>
                        <Button @click.stop="onSaveIndicator('save')" type="primary">保存</Button>
                    </div>
                </div>
            </div>
        </DropdownMenu>
    </Dropdown>

</template>

<script>
import mixins from '@/mixins/index.js';
export default {
    name: 'quort-history',
    mixins: [mixins],
    watch: {
        'tableParams.type'() {
            this.indicatorList = this.deepClone(this.indicatorListDefault);
        },

        indicatorListQuo: {
            handler() {
                const arr = [];
                if (this.indicatorList) {
                    for (let i in this.indicatorList) {
                        arr.push(...this.indicatorList[i]);
                    }
                    this.indicatorArr = arr;
                    this.indicatorList = this.indicatorListQuo ? this.indicatorListQuo : {};
                    if (this.indicatorList && this.indicatorList[0]) {
                        this.indicatorRowSelect = {
                            0: this.indicatorList[0].every(item => item.selected),
                            1: this.indicatorList[1].every(item => item.selected),
                            2: this.indicatorList[2].every(item => item.selected),
                        };
                    }
                } else {
                    this.indicatorArr = [];
                    this.indicatorList = {};
                }
            },
            immediate: true,
            deep: true,
        },
    },
    props: {
        indicatorListQuo: {
            default: () => {},
        },
        indicatorListDefault: {
            default: () => {},
        },
        tableParams: {
            default: () => {},
        },
        w: {
            default: '7rem',
            type: String,
        },
    },
    data() {
        return {
            //指标组名
            indicatorRowSelect: {},
            indicatorArr: [],
            visible: false,
            indicatorRowName: {
                0: '广告系列',
                1: '广告组',
                2: '广告',
            },
        };
    },
    mounted() {
        this.$emit('onIndicatorList', this.indicatorList);
    },
    computed: {
        // 指标数量
        indicatLength() {
            if (this.indicatorList[0]) {
                if (!this.typeKey(this.tableParams.type)) {
                    let length = {
                        0: this.indicatorList[0].length,
                        1: this.indicatorList[1].length,
                        2: this.indicatorList[2].length,
                    };
                    return length[0] + length[1] + length[2];
                } else {
                    return this.indicatorList[this.typeKey(this.tableParams.type)].length;
                }
            } else {
                return 0;
            }
        },
        // 指标选择数
        indicatorRowLength() {
            if (this.indicatorList[0]) {
                if (!this.typeKey(this.tableParams.type)) {
                    let length = {
                        0: this.indicatorList[0].filter(item => item.selected).length,
                        1: this.indicatorList[1].filter(item => item.selected).length,
                        2: this.indicatorList[2].filter(item => item.selected).length,
                    };
                    return length[0] + length[1] + length[2];
                } else {
                    return this.indicatorList[this.typeKey(this.tableParams.type)].filter(item => item.selected).length;
                }
            } else {
                return 0;
            }
        },
        // 指标栏是否默认
        isDefaultIndicator() {
            return !this.indicatorArr.some(item => item.selected != item.isDefault) || this.indicatorArr.every(item => !item.selected);
        },
        // 指标字符串
        indicatorString() {
            let str = '';
            if (!this.isDefaultIndicator) {
                str = this.indicatorArr
                    .filter(item => item.selected)
                    .map(item => item.code)
                    .join(',');
            }
            return str;
        },
    },
    methods: {
        //tableParams.type类型转化值
        typeKey(value) {
            if (value == 'series') {
                return '0';
            } else if (value == 'campaign') {
                return '1';
            } else if (value == 'offer') {
                return '2';
            } else {
                return '';
            }
        },
        /*
		 * @description 清理指标
		 */
        clearIndicator() {
            if (this.typeKey(this.tableParams.type)) {
                this.indicatorList[this.typeKey(this.tableParams.type)].forEach(item => (item.selected = false));
            } else {
                for (let i in this.indicatorList) {
                    this.indicatorList[i].forEach(item => (item.selected = false));
                }
            }
        },
        /*
		 * @description 点击指标取消，确定按钮
		 */
        onSaveIndicator(type) {
            this.visible = false;
            if (this.isDefaultIndicator) {
                for (let i in this.indicatorList) {
                    this.indicatorList[i].forEach(item => (item.selected = item.isDefault));
                }
            }
            if (type == 'save') {
                this.$emit('onIndicatorList', this.indicatorList);
            } else {
                for (let i in this.indicatorList) {
                    this.indicatorList[i].forEach(item => (item.selected = item.isDefault));
                }
                // this.indicatorList = this.indicatorList;
            }
        },
        /**
         * @description 默认指标
         */
        resetIndicator() {
            console.log(this.tableParams.type, '....指标');
            if (this.typeKey(this.tableParams.type)) {
                this.indicatorList[this.typeKey(this.tableParams.type)].forEach(item => (item.selected = item.isDefault));
            } else {
                for (let i in this.indicatorList) {
                    this.indicatorList[i].forEach(item => (item.selected = item.isDefault));
                }
            }
        },
        /**
         * @description 指标分组全选
         * @param value:string 选择的组
         */
        selectIndicatorRow(value) {
            const bool = !this.indicatorRowSelect[value];
            this.indicatorList[value].forEach(item => (item.selected = bool));
        },
        onShow () {
            this.visible=!this.visible
        }
    },
};
</script>

<style lang="scss">
//指标box
.ivu-select-dropdown.ivu-dropdown-transfer {
    max-height: 7rem;
}
.header-button-ghost-down {
    &.tf {
        transform: rotate(180deg);
        border-right: 1px solid #dfe2e5;
        border-left: none;
    }
}
.default-history-manage-list-wrap {
    .indicator-box {
        width: 7rem;
        max-height: 7rem;
        .indicator-list {
            display: flex;
            .indicator-row {
                display: flex;
                flex: 0 0 2rem;
                flex-direction: column;
                & > .indicator-item:nth-of-type(1) {
                    font-size: 0.16rem;
                    line-height: 0.5rem;
                    margin-bottom: 0.1rem;
                    border-bottom: 1px solid #dfe2e5;
                }
                &.history-row {
                    flex: 0 0 3rem;
                    .history-cell-wrap {
                        display: flex;
                        .indicator-item {
                            margin-bottom: 0;
                            border: none;
                            display: flex;
                            align-items: center;
                            padding: 0 0.2rem;
                            line-height: 0.3rem;
                            font-size: 0.14rem;
                        }
                    }
                    .row-box {
                        display: flex;
                        flex-direction: column;
                        flex: 0 0 1.5rem;
                        .indicator-item {
                        }
                    }
                }

                .indicator-item {
                    display: flex;
                    align-items: center;
                    padding: 0 0.2rem;
                    line-height: 0.3rem;
                    font-size: 0.14rem;
                    .icon-checkbox {
                        margin-right: 0.1rem;
                        width: 0.16rem;
                        height: 0.16rem;
                        background-position: -0.07rem -1.66rem;
                        &.disabled {
                            border-color: #dfe2e5 !important;
                            background-color: #dfe2e5 !important;
                        }
                    }
                }
            }
        }
        .indicator-footer {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0.2rem 0.5rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/commons/quota-history.vue